import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const REGED_BROKER_DEALER_FORMATS_QUERY_KEY = 'regEdBrokerDealerFormats';

/**
 * Formats an explicitly named broker-dealer supports. The account-scoped
 * `useRegEdSupportedFormatsQuery` derives the firm from the caller's integration, which admin
 * tooling has none of — it operates as no account at all, so the firm is named in the path.
 */
export const useRegEdBrokerDealerFormatsQuery = (brokerDealerId: string | null | undefined) => {
	const userSession = useUserSession();
	return useQuery({
		enabled: !!brokerDealerId,
		queryKey: [REGED_BROKER_DEALER_FORMATS_QUERY_KEY, brokerDealerId ?? null],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<string[]>({
				path: `admin/compliance/regEd/brokerDealers/${encodeURIComponent(brokerDealerId!)}/supportedFormats`,
				method: 'GET',
			}),
		meta: {
			toastErrorMessage: 'Failed to load the formats for this broker-dealer.',
		},
	});
};
